module.exports = __webpack_public_path__ + "img/login5.7842c46e.gif";